import React, {
    useEffect,
} from "react";
import {useDispatch, useSelector} from 'react-redux';

import {
    List,
    Button,
    Skeleton
} from 'antd';
import {Link} from 'react-router-dom';
import {UserOutlined} from '@ant-design/icons';

import * as T from 'utils/types';
import TotalResult from "components/panel/TotalResult";
import {rsrTabThunks} from "./RsrTabSlice";
import Error500 from "components/errors/Error500";
import ResearcherListTitle from "components/researcher/ResearcherListTitle";

// researcher tab
export default () => {




    const dispatch = useDispatch();

    const {
        searchInput,
        keywordType,
        facultyID,
        departmentID,
        searchTab,
        rsrSpecific: {
            acceptingGraduateStudentChecked,
            C3IChecked,
            SDGs
        }
    } = useSelector((state: T.RootState) => state.searchPgUserInputs);

    useEffect(()=>{
        searchTab === T.SearchTab.RESEARCHERS && dispatch(rsrTabThunks.initList({
            keywordType, searchInput, acceptingGraduateStudentChecked, C3IChecked,
            facultyID, departmentID,
            SDGs
        }));
    }, [
        keywordType, searchInput, acceptingGraduateStudentChecked, C3IChecked,
        facultyID, departmentID,
        SDGs, dispatch, searchTab
    ]);




    const {
        total,
        status,
        hasNext,
        rsrList,
    } = useSelector((state: T.RootState) => state.rsrTab);

    return <>
        { total>=0 && <TotalResult searchResult={total}/> }


        { status!=="failed"&&<List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(rsrTabThunks.loadMore())}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={rsrList}
            renderItem={item => {
                const rsr = item.item as T.Researcher;
                const icon = rsr && <Link to={`/profile/${rsr.random_id}`}>
                    <UserOutlined className="sfu-grey-link" style={{ fontSize: '16px', marginTop: '4px' }}/>
                </Link>;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        {<List.Item.Meta
                            avatar={icon}
                            title={<ResearcherListTitle researcher={rsr}/>}
                        />}
                    </Skeleton>
                </List.Item>;
            }} 
        />}


        { status==="failed"&&<Error500/>}



    </>
}
